module.exports = __webpack_public_path__ + "static/media/undraw_statistic_chart_38b6.2b75718a.png";